<script setup lang="ts">
const { $termsModal } = useNuxtApp()

const visible = ref(false)

const handleTermsClick = () => {
  $termsModal.show('terms')
}

const handlePrivacyClick = () => {
  $termsModal.show('privacy')
}

watch(
  () => useRoute().fullPath,
  () => {
    const route = useRoute()
    const isDataRoute = route.path === '/data' || route.fullPath.startsWith('/data?') || route.fullPath.startsWith('/data/?')
    visible.value = isDataRoute || route.path.includes('/quick')
  },
  { immediate: true }
)
</script>

<template>
  <footer v-if="visible" id="footer" class="outer">
    <ul class="agree">
      <li><a @click="handleTermsClick">이용약관</a></li>
      <li><a @click="handlePrivacyClick">개인정보처리방침</a></li>
    </ul>
    <p class="copyright">COPYRIGHT © EDUBRAIN, 2024. All rights reserved.</p>
  </footer>
</template>

<style scoped></style>
